import React from "react"
import Skeleton from "react-loading-skeleton"

function CampaignCardSkeleton() {
  return (
    <div className="uk-flex uk-flex-column">
      <Skeleton className="uk-margin-small-bottom" height={14} width={120} />
      <Skeleton height={330} />
    </div>
  )
}

export default CampaignCardSkeleton
